import React from "react";

const CustomCourse = () => {
  return <div>CustomCourse</div>;
};

export default CustomCourse;
